import Router from "next/router";

export const openHref = (href?: string) => {
  if (href) {
    const url = href.startsWith("http") ? href : `https://${href}`;
    const urlHref = new URL(url);
    const urlArray = urlHref.pathname.split("/");

    if (urlHref.hostname === "onlinepatent.ru" && urlArray[1] === "journal") {
      Router.push(urlArray[2]);
    } else {
      window.open(url, "_blank");
    }
  }
};
